import styled from 'styled-components';

export const Container = styled.footer`
    margin-left: 230px;
    padding: 0;
    
    .link a{
        cursor: default
    }

    .uk-section-secondary{
        background: #043C5A;
    }

    .logo-footer{
        width: 230px;
    }

    p{
        color: #ffff;
        font-weight: 700;
        font-size: 17px;
        margin-bottom: 5px;
    }

    span {
        color: #fff;
        margin-top: 0;
        font-weight: 700;
        font-size: 19px;    
    }

    .img-whatsapp {
        width: 35px;
        height: 35px;
        margin-right: 15px;
    }

    .container-whats{
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        p, span {
            margin-bottom: 0;
            font-family: 'Roboto', sans-serif;
        }

        span{
            font-size: 25px;
        }
    }

    @media only screen and  (max-width: 789px){
        margin-left: 0px!important;    
    }


    .container-footer-texto{
        @media only screen and  (max-width: 600px){
            display: flex;
            flex-direction: column;
        }
    }

`;

export const DivLinha = styled.div`
    width: 100%;
    height: 1.5px;
    background-color: #ffff;
    margin-bottom: 10px;
    margin-top: 10px;
`;